import { Action } from '@ngrx/store';

export const SEARCH          = '[Action] Search';
export const SEARCH_BY_MONTH = '[Action] Search by month';
export const SEARCH_BY_DAY   = '[Action] Search by day';

export class Search implements Action {
  readonly type = SEARCH;
  constructor(public payload: string) { }
}
export class SearchByMonth implements Action {
  readonly type = SEARCH_BY_MONTH;
  constructor(public payload: string) { }
}
export class SearchByDay implements Action {
  readonly type = SEARCH_BY_DAY;
  constructor(public payload: string) { }
}

export type All
  = Search | SearchByMonth | SearchByDay;



// WEBPACK FOOTER //
// /Users/shwld/project/shwld/home-counter/app_src/src/app/store/action/action.actions.ts